import {createAction, createAsyncAction} from "typesafe-actions"

export const openSingleRecordWSConnectionAsync = createAsyncAction(
    "@@ws/OPEN_SINGLE_RECORD_CONNECTION",
    "@@ws/OPEN_SINGLE_RECORD_CONNECTION_SUCCESS",
    "@@ws/OPEN_SINGLE_RECORD_CONNECTION_FAILURE",
)<undefined, undefined, unknown>();
export const closeSingleRecordWSConnection = createAction("@@ws/CLOSE_SINGLE_RECORD_CONNECTION")<{ code?: number, reason?: string }>();

export const openAvailableRecordsWSConnectionAsync = createAsyncAction(
    "@@ws/OPEN_AVAILABLE_RECORDS_CONNECTION",
    "@@ws/OPEN_AVAILABLE_RECORDS_CONNECTION_SUCCESS",
    "@@ws/OPEN_AVAILABLE_RECORDS_CONNECTION_FAILURE",
)<undefined, undefined, unknown>();
export const closeAvailableRecordsWSConnection = createAction("@@ws/CLOSE_AVAILABLE_RECORDS_CONNECTION")<{ code?: number, reason?: string }>();

export const pingError = createAction("@@ws/PING_ERROR")<unknown>();